export type SessionIssue = { icon: string; key: string; summary: string; description: string };

export function deserializeIssue(serializedIssue: string): SessionIssue {
	try {
		return JSON.parse(serializedIssue);
	} catch (error) {
		return { key: '', summary: '', description: '', icon: '' };
	}
}

export const serializeIssue = (issue: SessionIssue): string => {
	try {
		return JSON.stringify(issue);
	} catch (error) {
		console.error('Error serializing issue:', error);
		return '';
	}
};
